export default () => {
  const data = {
    event_name: 'click',
    button_name: 'logo',
    page_section: 'header',
    name_of_the_page_viewed: 'development_details_personal',
  };
  return data;
};
